import { Component, HostBinding, Input } from "@angular/core";
import { FormTemplateQuestion } from "src/app/main/model/forms/form-template-question.model";
import {
  FormTemplateSection,
  FormTemplateSectionType,
  SectionDirection,
} from "src/app/main/model/forms/form-template-section.model";
import { ThemeService } from "src/app/main/services/theme/theme.service";
import { hasKey } from "src/app/main/util/object.util";
import { FormTemplateSectionBaseComponent } from "../../form-template-base/form-template-section-base.component";

@Component({
  selector: "app-form-completion-template-section",
  templateUrl: "./form-completion-template-section.component.html",
  styleUrls: ["./form-completion-template-section.component.scss"],
  standalone: false,
})
export class FormCompletionTemplateSectionComponent extends FormTemplateSectionBaseComponent {
  @HostBinding("class.box") @Input() public isSubSection;

  public sectionDirection = SectionDirection;
  public FormTemplateSectionType = FormTemplateSectionType;

  constructor(public themeService: ThemeService) {
    super();
  }

  public contentDirection(section: FormTemplateSection) {
    let firstQuestion: FormTemplateQuestion;
    if (!section.formTemplateQuestions.length) {
      return SectionDirection.Horizontal;
    }
    if (!this.isFormTemplateSection(section.formTemplateQuestions[0])) {
      firstQuestion = section.formTemplateQuestions[0];
    } else {
      firstQuestion = section.formTemplateQuestions[0]
        .formTemplateQuestions[0] as FormTemplateQuestion;
    }

    return FormTemplateQuestion.isQuestionRange(firstQuestion)
      ? SectionDirection.Vertical
      : SectionDirection.Horizontal;
  }

  public questionContainer(question: FormTemplateQuestion): string {
    if (FormTemplateQuestion.isQuestionList(question)) {
      return "box";
    } else {
      return "qus-wrap question-row";
    }
  }

  public isFormTemplateSection(
    question: FormTemplateQuestion | FormTemplateSection
  ): question is FormTemplateSection {
    return hasKey(question, "parentFormTemplateSectionId");
  }

  /**
   * Whether a row break must be rendered after an item, so the item ends its row and the next
   * item starts a new one. Only applies between side-by-side tiles in a horizontal section;
   * anywhere else the next item already starts a new row, so no break is rendered.
   * @param section The section whose items are being rendered.
   * @param index Index of the item in `section.formTemplateQuestions`.
   * @returns True when a row break element should follow the item.
   */
  public hasRowBreakAfter(section: FormTemplateSection, index: number): boolean {
    const item = section.formTemplateQuestions[index];
    const next = section.formTemplateQuestions[index + 1];
    if (!item?.viewMeta?.rowBreak || !next) {
      return false;
    }
    return (
      this.contentDirection(section) === SectionDirection.Horizontal &&
      this._isTile(item) &&
      this._isTile(next)
    );
  }

  /**
   * Whether an item renders as a tile that shares its row with others in a horizontal section.
   * @param item A question or sub-section of the section.
   * @returns True for List questions and sub-sections.
   */
  private _isTile(item: FormTemplateQuestion | FormTemplateSection): boolean {
    return this.isFormTemplateSection(item) || this.questionContainer(item) === "box";
  }
}
